import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { SalariesActions } from '@features/referentiel/actions/salarie.actions';
import { EntreprisePageActions } from '@features/demande-financement/action-individuelle/features/entreprise/store/actions/entreprise-page.actions';
import { SalarieService } from '@features/referentiel/services/salarie.service';
import { selectStateForms } from '@root/selectors/router.selectors';
import { Store } from '@ngrx/store';
import { StatutUrl } from '@shared/constants';



@Injectable()
export class SalarieEffects {

    initSalaries$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntreprisePageActions.selectEntreprise, EntreprisePageActions.changeEntreprise),
            map((action) => SalariesActions.getSalaries({ siret: action.siret }))
        )
    );

    initSalariesFromMapping$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntreprisePageActions.setState),
            map((action) => SalariesActions.getSalaries({ siret: action.state.form.value.siret }))
        )
    );

    loadSalaries$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SalariesActions.getSalaries),
            withLatestFrom(this.store$.select(selectStateForms)),
            switchMap(([action, stateForm]) => {
              if(stateForm !== StatutUrl.read) {
                return this.salariesService.getContactsBySiret(action.siret).pipe(
                  map((salaries) => SalariesActions.getSalariesSuccess({ salaries })),
                  catchError((error) => of(SalariesActions.getSalariesFailure({ errorMessage: error })))
                );
              }
              return of(SalariesActions.noActions());
            }
            )
        )
    );

    resetSalaries$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EntreprisePageActions.resetEntrepriseForm),
            map(() => SalariesActions.resetSalariesResearch())
        )
    );

    constructor(private actions$: Actions, private salariesService: SalarieService, private readonly store$: Store) { }
}
